import { render } from "./IconPhone.vue?vue&type=template&id=9c48c174"
const script = {}

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__